import configureStoreDev from "./configureStore.dev";
import configureStoreProd from "./configureStore.prod";
import configureStoreStaging from "./configureStore.staging";

let configureStore;

if (process.env.REACT_APP_REDUX_DEVTOOLS) {
  configureStore = configureStoreDev;
} else if (["production"].includes(process.env.REACT_APP_ENV)) {
  configureStore = configureStoreProd;
} else if (["staging"].includes(process.env.REACT_APP_ENV)) {
  configureStore = configureStoreStaging;
} else {
  configureStore = configureStoreDev;
}

export default configureStore;
